// Mapeia o enum granular de status de pedido para os 4 buckets do documento
// (Seção 2.8.1, 3.6.2): PENDING, PAID, CANCELED, REFUNDED.
//
// Espelha o helper de backend `mapStatusToBucket`. Labels visíveis vêm
// de `utils/enums.js` (fonte única de tradução pt-BR).

import { ORDER_STATUS_LABELS, formatOrderStatus } from './enums';

const STATUS_BUCKETS = {
  pending: 'PENDING',
  awaiting_approval: 'PENDING',
  approved: 'PENDING',
  paid: 'PAID',
  shipped: 'PAID',
  delivered: 'PAID',
  cancelled: 'CANCELED',
  rejected: 'CANCELED',
  refunded: 'REFUNDED'
};

const BUCKET_COLORS = {
  PENDING: 'amber',
  PAID: 'green',
  CANCELED: 'red',
  REFUNDED: 'gray'
};

export function mapStatusToBucket(status) {
  return STATUS_BUCKETS[status] || 'PENDING';
}

export function getStatusLabel(status) {
  return formatOrderStatus(status);
}

export function getBucketLabel(bucket) {
  return ORDER_STATUS_LABELS[bucket] || bucket;
}

export function getBucketColor(bucket) {
  return BUCKET_COLORS[bucket] || 'gray';
}

export function formatOrderNumber(order) {
  if (!order) return '';
  if (order.sequentialNumber != null && order.sequentialYear != null) {
    return `${String(order.sequentialNumber).padStart(3, '0')}/${String(order.sequentialYear).slice(-2)}`;
  }
  return `#${order.id}`;
}

export const STATUS_BUCKETS_LIST = ['PENDING', 'PAID', 'CANCELED', 'REFUNDED'];
